import { ReactNode } from 'react';
import classes from './MintStatus.module.css';
import { Group, Text } from '@mantine/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export const getTypeColor = (type: string) => {
	switch (type) {
		case 'success':
			return classes.successColor;
		case 'warning':
			return classes.warningColor;
		case 'error':
			return classes.errorColor;
		default:
			return classes.defaultColor;
	}
};

export const MintStatus = (props: {
	children: ReactNode;
	type: string;
}) => {
	const { t } = useTranslation();
	return (
		<Group gap="4px">
			{props.type && (
				<Text
					className={clsx(
						classes.dot,
						getTypeColor(props.type)
					)}
				>
					●
				</Text>
			)}
			<Text
				className={clsx(
					classes.text,
					getTypeColor(props.type)
				)}
			>
				{t(`global.${props.children}`)}
			</Text>
		</Group>
	);
};
